import { fmtAgo, fmtDateTime } from './format';

/** "3 小時前", with the exact time on hover. */
export function When({ at }: { at: string | null | undefined }) {
  if (!at) return <span className="faint">—</span>;
  return (
    <time dateTime={at} title={fmtDateTime(at)} className="nowrap">
      {fmtAgo(at)}
    </time>
  );
}
